"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const Literals_1 = require("./Literals");
class Context {
    constructor() {
        this.rootHashes = [];
        this.objects = new Map();
        this.literals = new Map();
    }
    has(hash) {
        var _a;
        return this.literals.has(hash) || this.objects.has(hash) ||
            (((_a = this === null || this === void 0 ? void 0 : this.resources) === null || _a === void 0 ? void 0 : _a.aliasing) !== undefined && this.resources.aliasing.has(hash));
    }
    toLiteralContext() {
        return { rootHashes: Array.from(this.rootHashes), literals: Object.fromEntries(this.literals.entries()) };
    }
    fromLiteralContext(literalContext) {
        this.rootHashes = Array.from(literalContext.rootHashes);
        this.literals = new Map(Object.entries(literalContext.literals));
        this.objects = new Map();
    }
    merge(other) {
        var _a, _b;
        const roots = new Set(this.rootHashes.concat(other.rootHashes));
        this.rootHashes = Array.from(roots);
        for (const [hash, literal] of other.literals.entries()) {
            if (!this.literals.has(hash)) {
                this.literals.set(hash, literal);
            }
        }
        for (const [hash, obj] of other.objects.entries()) {
            if (!this.objects.has(hash)) {
                this.objects.set(hash, obj);
            }
        }
        if (this.resources === undefined) {
            this.resources = other.resources;
        }
        else {
            if (((_a = other.resources) === null || _a === void 0 ? void 0 : _a.aliasing) !== undefined) {
                if (((_b = this.resources) === null || _b === void 0 ? void 0 : _b.aliasing) === undefined) {
                    this.resources.aliasing = new Map();
                }
                for (const [hash, aliased] of other.resources.aliasing.entries()) {
                    if (!this.resources.aliasing.has(hash)) {
                        this.resources.aliasing.set(hash, aliased);
                    }
                }
            }
        }
    }
    // if a dependency is in more than one subobject, it will pick one of the shortest dep chains.
    findMissingDeps(hash, chain, missing) {
        if (chain === undefined) {
            chain = [];
        }
        if (missing === undefined) {
            missing = new Map();
        }
        let literal = this.literals.get(hash);
        if (literal === undefined) {
            let prevChain = missing.get(hash);
            if (prevChain === undefined || chain.length < prevChain.length) {
                missing.set(hash, chain);
            }
        }
        else {
            for (const dep of literal.dependencies) {
                let newChain = chain.slice();
                newChain.unshift(hash);
                this.findMissingDeps(dep.hash, newChain, missing);
            }
        }
        return missing;
        ;
    }
    checkLiteralHashes() {
        let result = true;
        for (const [hash, literal] of this.literals.entries()) {
            if (hash !== literal.hash || !Literals_1.LiteralUtils.validateHash(literal)) {
                result = false;
                break;
            }
        }
        return result;
    }
    checkRootHashes() {
        let result = true;
        for (const hash of this.rootHashes) {
            if (!this.literals.has(hash)) {
                result = false;
                break;
            }
        }
        return result;
    }
}
exports.Context = Context;
//# sourceMappingURL=Context.js.map